import React from "react";
import styled from "styled-components";
import { CheckIcon } from "./Icons";

const CustomRadio = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #0065c0;
  margin-right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${(props) => (props.checked ? "#0065c0" : "transparent")};
  transition: background-color 0.2s, border-color 0.2s;

  .icon {
    width: 24px;
    height: 24px;
    transform: ${(props) => (props.checked ? "scale(1)" : "scale(0)")};
    transition: transform 0.3s ease;
  }
`;

const RadioButtonLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: ${(props) => (props.checked ? "bold" : "normal")};
`;

const RadioInput = styled.input.attrs({ type: "radio" })`
  display: none;
`;

const CustomRadioButton = ({ label, name, checked, onChange }) => {
  return (
    <RadioButtonLabel checked={checked}>
      <RadioInput name={name} checked={checked} onChange={onChange} />
      <CustomRadio checked={checked}>
        <span className="icon">{checked && <CheckIcon color="#FFF" />}</span>
      </CustomRadio>
      {label}
    </RadioButtonLabel>
  );
};

export default CustomRadioButton;
